import { gql } from '@apollo/client'

const BOARD_MENU_QUERY = gql`
  query BOARD_MENU_QUERY {
    modelBoards {
      nodes {
        title
        slug
        acfModelBoardsCover {
          hidden
        }
        acfModelBoardParent {
          departmentOrder {
            nodes {
              ... on ModelBoard {
                title
                slug
                acfModelBoardsCover {
                  hidden
                }
              }
            }
          }
        }
      }
    }
  }
`

export default BOARD_MENU_QUERY
